import { tv } from 'tailwind-variants';

import { Icon } from '@frontendmentorio/design-system-v2';

const ICONS = {
  astro: { name: 'code' },
  css: { name: 'css3', style: 'brands' },
  gif: { name: 'image' },
  hbs: { name: 'ember', style: 'brands' },
  htm: { name: 'html5', style: 'brands' },
  html: { name: 'html5', style: 'brands' },
  jpeg: { name: 'image' },
  jpg: { name: 'image' },
  js: { name: 'js', style: 'brands' },
  json: { name: 'brackets-curly' },
  jsx: { name: 'react', style: 'brands' },
  less: { name: 'less', style: 'brands' },
  md: { name: 'markdown', style: 'brands' },
  mdx: { name: 'markdown', style: 'brands' },
  png: { name: 'image' },
  sass: { name: 'sass', style: 'brands' },
  scss: { name: 'sass', style: 'brands' },
  svg: { name: 'code' },
  styl: { name: 'brackets-curly' },
  ts: { name: 'js', style: 'brands' },
  tsx: { name: 'react', style: 'brands' },
  vue: { name: 'vuejs', style: 'brands' },
  webp: { name: 'image' },
};

const styles = tv({
  base: [
    'flex',
    'items-center',
    'gap-3',
    'px-3',
    'py-[0.2rem]',
    'rounded',
    'w-full',
    'whitespace-nowrap',
    'disabled:cursor-auto',
    'disabled:text-neutral-500',
    'disabled:hover:bg-transparent',
    'hover:bg-[hsl(0,0%,91%)]',
  ],
  variants: {
    isSelectedFile: {
      true: ['bg-[hsl(208,76%,90%)]', 'hover:bg-[hsl(208,76%,90%)]'],
    },
  },
});

export default function File({
  file,
  selectedFile,
  setIsEditorVisible,
  setSelectedFile,
}) {
  const isSelectedFile = file === selectedFile;

  const handleClick = () => {
    setIsEditorVisible(true);
    setSelectedFile(file);
  };

  return (
    <button
      className={styles({ isSelectedFile })}
      disabled={!file.isAllowed}
      onClick={handleClick}
    >
      <span className="flex justify-center text-sm w-[1rem]">
        <Icon
          name={ICONS[file.extension]?.name || 'terminal'}
          style={ICONS[file.extension]?.style}
        />
      </span>

      <span className="overflow-hidden text-ellipsis text-sm">{file.name}</span>
    </button>
  );
}
